document.addEventListener("DOMContentLoaded", () => {
  let currentStep = 1;
  const questions = Array.from(document.querySelectorAll(".quiz-question"));

  function showStep(step) {
    questions.forEach(q => q.classList.remove("active"));
    const activeQ = document.querySelector(`.quiz-question[data-step="${step}"]`);
    if (activeQ) activeQ.classList.add("active");
  }

  // welcome/back/start handlers
  const welcomeBackButton = document.querySelector('.welcome-back-button');
  if (welcomeBackButton) {
    welcomeBackButton.addEventListener("click", () => {
      document.getElementById("quiz-welcome").classList.remove("hidden");
      document.getElementById("quiz-questions").classList.add("hidden");
      document.getElementById("quizResults").classList.add("hidden");
      currentStep = 1;
    });
  }

  const startBtn = document.querySelector(".welcome-section-quiz-start-button");
  if (startBtn) {
    startBtn.addEventListener("click", () => {
      document.getElementById("quiz-welcome").classList.add("hidden");
      document.getElementById("quiz-questions").classList.remove("hidden");
      currentStep = 1;
      showStep(currentStep);
    });
  }

  // Next / Submit and Back handling
  document.addEventListener("click", (e) => {
    if (e.target.classList.contains("next-btn")) {
      const isLast = currentStep === questions.length;

      if (!isLast) {
        currentStep++;
        if (currentStep <= questions.length) showStep(currentStep);
      } else {
        // last step = Submit -> validate email/phone
        const lastQuestion = document.querySelector(`.quiz-question[data-step="${questions.length}"]`);
        const emailInput = lastQuestion?.querySelector(".quiz-page-email-element");
        const emailError = lastQuestion?.querySelector(".email-error");
        const phoneInput = lastQuestion?.querySelector(".quiz-page-mobile-element");
        const phoneError = lastQuestion?.querySelector(".phone-error");

        const emailVal = emailInput ? emailInput.value.trim() : "";
        const phoneVal = phoneInput ? phoneInput.value.trim() : "";

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const phoneRegex = /^[0-9]{10}$/;

        const isEmailValid = emailVal && emailRegex.test(emailVal);
        const isPhoneValid = phoneVal && phoneRegex.test(phoneVal);

        if (!isEmailValid && !isPhoneValid) {
          if (emailError) {
            emailError.textContent = "Please enter a valid email or phone number";
            emailError.style.display = "inline";
          }
          if (phoneError) {
            phoneError.textContent = "Please enter a valid email or phone number";
            phoneError.style.display = "inline";
          }
          return; // stop submission
        }

        // hide errors
        if (emailError) emailError.style.display = "none";
        if (phoneError) phoneError.style.display = "none";

        // send both (if one is empty, backend will save "No email"/"No mobile")
        sendEmailToGoogleSheet(emailVal, phoneVal);

        // Show results
        showResults();
      }
    }

    // Back button
    if (e.target.classList.contains("prev-btn")) {
      if (currentStep > 1) {
        currentStep--;
        showStep(currentStep);
      }
    }
  });

  // Enable/disable Next button logic per question
  questions.forEach((question) => {
    const nextBtn = question.querySelector(".next-btn");
    if (!nextBtn) return;

    const radios = Array.from(question.querySelectorAll("input[type='radio']"));
    const checkboxes = Array.from(question.querySelectorAll("input[type='checkbox']"));
    const emailInput = question.querySelector("input[type='email'].quiz-page-email-element");
    const phoneInput = question.querySelector("input[type='number'].quiz-page-mobile-element");

    nextBtn.disabled = true;
    nextBtn.classList.add("disabled");

    // radios/checkboxes: enable on change
    [...radios, ...checkboxes].forEach(input => {
      input.addEventListener("change", () => {
        nextBtn.disabled = false;
        nextBtn.classList.remove("disabled");
      });
    });

    // email/phone: enable if either field has a value
    function toggleNext() {
      const emailVal = emailInput ? emailInput.value.trim() : "";
      const phoneVal = phoneInput ? phoneInput.value.trim() : "";
      if (emailVal.length > 0 || phoneVal.length > 0) {
        nextBtn.disabled = false;
        nextBtn.classList.remove("disabled");
      } else {
        nextBtn.disabled = true;
        nextBtn.classList.add("disabled");
      }
    }

    if (emailInput) emailInput.addEventListener("input", toggleNext);
    if (phoneInput) phoneInput.addEventListener("input", toggleNext);
  });

  // showResults: reveal product recommendations
  function showResults() {
    document.getElementById("quiz-questions").classList.add("hidden");
    document.getElementById("quizResults").classList.remove("hidden");

    const productQuestion = questions.find(q => q.dataset.enableProducts === "true");
    if (!productQuestion) {
      document.getElementById("recommended-products").innerHTML = "<p>No product recommendations configured.</p>";
      return;
    }

    const selected = productQuestion.querySelector("input[type='radio']:checked");
    if (!selected) {
      document.getElementById("recommended-products").innerHTML = "<p>Please select an option to see recommendations.</p>";
      return;
    }

    const choiceIndex = selected.getAttribute("data-choice");
    const productDiv = productQuestion.querySelector(`.quiz-products[data-choice="${choiceIndex}"]`);
    const recommendedContainer = document.querySelector("#recommended-products");
    recommendedContainer.innerHTML = "";

    if (productDiv) {
      recommendedContainer.appendChild(productDiv);
      productDiv.classList.remove("hidden");
      productDiv.classList.add("quiz-submitted");
      initCustomCarousels();
    }
  }

  // send email + mobile
  function sendEmailToGoogleSheet(email, mobile) {
    fetch("https://script.google.com/macros/s/AKfycbzEXgAsKOwnlwCTXy9d7d-r3DyN6Dr_vKAVQ8sw3dRuPd5EAn47JhCSW5yVoq2BBj71/exec", {
      method: "POST",
      mode: "no-cors",
      headers: {
        "Content-Type": "text/plain;charset=utf-8"
      },
      body: JSON.stringify({
        email: email || "No email",
        mobile: mobile || "No mobile"
      })
    }).catch(err => {
      console.log("send triggered (no-cors), cannot read response", err);
    });
  }

  // Init
  showStep(currentStep);
  document.querySelectorAll(".quiz-products.quiz-submitted").forEach(div => {
    div.classList.remove("quiz-submitted");
  });
});

